import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineStore } from "pinia";
import { ref } from "vue";
//@ts-ignore
import { getMortgageData } from "@services/realEstateAPI";
var MIN_MORTGAGE = 30000;
export var useMortgageStore = defineStore("mortgageStoreId", () => {
  /* Mortgage price per month */
  var installment = ref(0);
  /* Mortgage duration in years string */
  var duration = ref(0);
  /* Total Mortgage */
  var mortgageAmount = ref(0);
  /* Mortgage tan which can change if the tax type changes */
  var tan = ref(0);
  /* Rate */
  var rate = ref("");
  var setMortgageData = function setMortgageData(priceSale) {
    var dur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
    var tax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Fisso";
    return __awaiter(void 0, void 0, void 0, function* () {
      if (!mortgageAmount.value)
        // eslint-disable-next-line max-len
        mortgageAmount.value = priceSale - priceSale * 20 / 100 < priceSale * 50 / 100 ? priceSale * 50 / 100 : Math.round(priceSale - priceSale * 20 / 100);
      duration.value = dur;
      var {
        tasso,
        rata_eff
      } = yield getMortgageData({
        tasso: tax,
        importo: Math.round(mortgageAmount.value),
        durata: dur,
        finalita: "Acquisto",
        costo: Math.round(window["_priceSale"])
      });
      tan.value = tasso;
      installment.value = Math.round(rata_eff);
      rate.value = tax;
    });
  };
  return {
    installment,
    duration,
    mortgageAmount,
    tan,
    rate,
    setMortgageData
  };
});